import React from 'react';

var sizeMap = {
  small: 16,
  medium: 32,
  large: 64
};
function createIconComponent(name, defaultClassName, getSVGData) {
  var svgDataByHeight = getSVGData();
  var heights = Object.keys(svgDataByHeight);
  var Icon = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
    var ariaLabel = _ref['aria-label'],
        arialabelledby = _ref['aria-labelledby'],
        tabIndex = _ref.tabIndex,
        _ref$className = _ref.className,
        className = _ref$className === void 0 ? defaultClassName : _ref$className,
        _ref$fill = _ref.fill,
        fill = _ref$fill === void 0 ? 'currentColor' : _ref$fill,
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? 16 : _ref$size,
        _ref$verticalAlign = _ref.verticalAlign,
        verticalAlign = _ref$verticalAlign === void 0 ? 'text-bottom' : _ref$verticalAlign,
        id = _ref.id,
        title = _ref.title;
    var height = sizeMap[size] || size;
    var naturalHeight = closestNaturalHeight(heights, height);
    var naturalWidth = svgDataByHeight[naturalHeight].width;
    var width = height * (naturalWidth / naturalHeight);
    var path = svgDataByHeight[naturalHeight].path;
    var labelled = ariaLabel || arialabelledby;
    var role = labelled ? 'img' : undefined;
    return /*#__PURE__*/React.createElement("svg", {
      ref: forwardedRef,
      "aria-hidden": labelled ? undefined : 'true',
      tabIndex: tabIndex,
      focusable: tabIndex >= 0 ? 'true' : 'false',
      "aria-label": ariaLabel,
      "aria-labelledby": arialabelledby,
      className: className,
      role: role,
      viewBox: "0 0 ".concat(naturalWidth, " ").concat(naturalHeight),
      width: width,
      height: height,
      fill: fill,
      id: id,
      style: {
        display: 'inline-block',
        userSelect: 'none',
        verticalAlign: verticalAlign,
        overflow: 'visible'
      }
    }, title ? /*#__PURE__*/React.createElement("title", null, title) : null, path);
  });
  Icon.displayName = name;
  return Icon;
}

function closestNaturalHeight(naturalHeights, height) {
  return naturalHeights.map(function (naturalHeight) {
    return parseInt(naturalHeight, 10);
  }).reduce(function (acc, naturalHeight) {
    return naturalHeight <= height ? naturalHeight : acc;
  }, naturalHeights[0]);
}
var BrowserIcon = /*#__PURE__*/createIconComponent("BrowserIcon", "octicon octicon-browser", function () {
  return {
    "16": {
      "width": 16,
      "path": /*#__PURE__*/React.createElement("path", {
        d: "M0 2.75C0 1.784.784 1 1.75 1h12.5c.966 0 1.75.784 1.75 1.75v10.5A1.75 1.75 0 0 1 14.25 15H1.75A1.75 1.75 0 0 1 0 13.25ZM14.5 6h-13v7.25c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25Zm-6-3.5v2h6V2.75a.25.25 0 0 0-.25-.25ZM5 2.5v2h2v-2Zm-3.25 0a.25.25 0 0 0-.25.25V4.5h2v-2Z"
      })
    },
    "24": {
      "width": 24,
      "path": /*#__PURE__*/React.createElement("path", {
        d: "M0 3.75C0 2.784.784 2 1.75 2h20.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 22.25 22H1.75A1.75 1.75 0 0 1 0 20.25ZM22.5 7h-21v13.25c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25Zm-10-3.5v2h10V3.75a.25.25 0 0 0-.25-.25ZM7 3.5v2h4v-2Zm-5.25 0a.25.25 0 0 0-.25.25V5.5h4v-2Z"
      })
    }
  };
});
var HomeIcon = /*#__PURE__*/createIconComponent("HomeIcon", "octicon octicon-home", function () {
  return {
    "16": {
      "width": 16,
      "path": /*#__PURE__*/React.createElement("path", {
        d: "M6.906.664a1.749 1.749 0 0 1 2.187 0l5.25 4.2c.415.332.657.835.657 1.367v7.019A1.75 1.75 0 0 1 13.25 15h-3.5a.75.75 0 0 1-.75-.75V9H7v5.25a.75.75 0 0 1-.75.75h-3.5A1.75 1.75 0 0 1 1 13.25V6.23c0-.531.242-1.034.657-1.366l5.25-4.2Zm1.25 1.171a.25.25 0 0 0-.312 0l-5.25 4.2a.25.25 0 0 0-.094.196v7.019c0 .138.112.25.25.25H5.5V8.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v5.25h2.75a.25.25 0 0 0 .25-.25V6.23a.25.25 0 0 0-.094-.195Z"
      })
    },
    "24": {
      "width": 24,
      "path": /*#__PURE__*/React.createElement("path", {
        d: "M11.03 2.59a1.501 1.501 0 0 1 1.94 0l7.5 6.363a1.5 1.5 0 0 1 .53 1.144V19.5a1.5 1.5 0 0 1-1.5 1.5h-5.75a.75.75 0 0 1-.75-.75V14h-2v6.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-9.403c0-.44.194-.859.53-1.144ZM12 3.734l-7.5 6.363V19.5h5v-6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v6.25h5v-9.403Z"
      })
    }
  };
});
var XIcon = /*#__PURE__*/createIconComponent("XIcon", "octicon octicon-x", function () {
  return {
    "12": {
      "width": 12,
      "path": /*#__PURE__*/React.createElement("path", {
        d: "M2.22 2.22a.749.749 0 0 1 1.06 0L6 4.939 8.72 2.22a.749.749 0 1 1 1.06 1.06L7.061 6 9.78 8.72a.749.749 0 1 1-1.06 1.06L6 7.061 3.28 9.78a.749.749 0 1 1-1.06-1.06L4.939 6 2.22 3.28a.749.749 0 0 1 0-1.06Z"
      })
    },
    "16": {
      "width": 16,
      "path": /*#__PURE__*/React.createElement("path", {
        d: "M3.72 3.72a.75.75 0 0 1 1.06 0L8 6.94l3.22-3.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L9.06 8l3.22 3.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L8 9.06l-3.22 3.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L6.94 8 3.72 4.78a.75.75 0 0 1 0-1.06Z"
      })
    },
    "24": {
      "width": 24,
      "path": /*#__PURE__*/React.createElement("path", {
        d: "M5.72 5.72a.75.75 0 0 1 1.06 0L12 10.94l5.22-5.22a.749.749 0 0 1 1.275.326.749.749 0 0 1-.215.734L13.06 12l5.22 5.22a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215L12 13.06l-5.22 5.22a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042L10.94 12 5.72 6.78a.75.75 0 0 1 0-1.06Z"
      })
    }
  };
});

export { BrowserIcon, HomeIcon, XIcon };
